import { Button, ButtonProps } from 'antd';
import styled from 'styled-components';

const ButtonWrapper = styled.div`
  .ant-btn {
    border-radius: 16px;
  }

  .ant-btn-primary {
    background: var(--secondary) !important;
    color: #fff !important;
    border-color: var(--secondary) !important;
  }

  .ant-btn-default {
    background: var(--primary) !important;
    color: #fff !important;
    border-color: var(--primary) !important;
  }

  .ant-btn-dangerous {
    background-color: var(--red) !important;
    color: var(--white) !important;
    border-color: var(--red) !important;
  }

  .disabled {
    background-color: #fac91770 !important;
    color: white !important;
    border-color: #fac91770 !important;
  }
`;

export interface ButtonPropsInterface extends ButtonProps {
  borderLess?: boolean;
}

const button = (props: ButtonPropsInterface) => (
  <ButtonWrapper>
    <Button {...props} className={`w-full ${props.disabled ? 'disabled' : ''} ${props.className}`} />
  </ButtonWrapper>
);

export default button;
